import React from "react";
import style from "./Licence.module.css";
import PageLayout from "../../components/PageLayout/PageLayout";
import { icons } from "../../stuffs/Icons";

type Credit = {
  iconIndex: number;
  authorName: string;
  authorUrl: string;
  sourceName: string;
  sourceUrl: string;
};

const credits: Credit[] = [
  {
    iconIndex: 0,
    authorName: "Freepik",
    authorUrl: "https://www.freepik.com",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
  {
    iconIndex: 1,
    authorName: "Freepik",
    authorUrl: "https://www.freepik.com",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
  {
    iconIndex: 2,
    authorName: "Freepik",
    authorUrl: "https://www.freepik.com",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
  {
    iconIndex: 3,
    authorName: "Icongeek26",
    authorUrl: "https://www.flaticon.com/authors/icongeek26",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
  {
    iconIndex: 4,
    authorName: "Freepik",
    authorUrl: "https://www.freepik.com",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
  {
    iconIndex: 5,
    authorName: "Freepik",
    authorUrl: "https://www.freepik.com",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
  {
    iconIndex: 6,
    authorName: "Nikita Golubev",
    authorUrl: "https://www.flaticon.com/authors/nikita-golubev",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
  {
    iconIndex: 7,
    authorName: "Freepik",
    authorUrl: "https://www.freepik.com",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
  {
    iconIndex: 8,
    authorName: "Freepik",
    authorUrl: "https://www.freepik.com",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
  {
    iconIndex: 9,
    authorName: "Freepik",
    authorUrl: "https://www.freepik.com",
    sourceName: "Flaticon",
    sourceUrl: "https://www.flaticon.com/",
  },
];

const Licence: React.FC = () => {
  return (
    <PageLayout className={style.Licence}>
      <div className={style.Hero}>
        <h1 className={style.Title}>Licencje / Credits</h1>

        <p className={style.Subtitle}>
          Informacje o autorach ikon wykorzystanych w aplikacji.
        </p>
      </div>

      <div className={style.Grid}>
        {credits.map((c) => (
          <div className={style.Card} key={`${c.iconIndex}-${c.authorName}`}>
            <div className={style.IconBox}>{icons[c.iconIndex]?.svg}</div>

            <div className={style.CardBody}>
              <div className={style.CardLabel}>Autor</div>

              <a
                className={style.Link}
                href={c.authorUrl}
                target="_blank"
                rel="noreferrer"
                title={c.authorName}
              >
                {c.authorName}
              </a>

              <div className={style.CardLabel} style={{ marginTop: 10 }}>
                Źródło
              </div>

              <a
                className={style.Link}
                href={c.sourceUrl}
                target="_blank"
                rel="noreferrer"
                title={c.sourceName}
              >
                {c.sourceName}
              </a>
            </div>
          </div>
        ))}
      </div>
    </PageLayout>
  );
};

export default Licence;